<template>
    <div class="edit_point"  v-if="addOk">
        <el-card class="edit_point_account">
           <div slot="header" class="clearfix" style="text-align:center;">
                <span>编号</span><span style="color:red">{{myCode}}</span>
            </div>
            <div class="editContent">
                

                <p>
                    <span class="e_left">流程类型：</span>
                    <el-input v-model="myStatus"></el-input>
                </p>
                <!--<p>
                    <span class="e_left">积分：</span>
                    <el-input v-model="myPoints"></el-input>
                </p>-->

                <div v-if="status!=100">
                <p>
                    <span class="e_left">价格(分)：</span>
                    <el-input v-model="myPrice" ></el-input>
                </p>
                <p >
                    <span class="e_left">是否获取用户信息：</span>
                    <el-switch
                          v-model="bGetUserInfo"
                          active-color="#13ce66"
                          inactive-color="#dddddd"
                          active-value="1"
                          inactive-value="0"
                          >
                          </el-switch>
                </p>

                <p>
                    <span class="e_left">是否重复领取：</span>
                  <el-switch
                        v-model="bRepeat"
                        active-color="#13ce66"
                        inactive-color="#dddddd"
                        active-value="1"
                        inactive-value="0"
                        @change="changeRepeat()">
                        </el-switch>
                </p>
                <p v-if="myExtendInfo.day!=0">
                    <span class="span_1" >每x天可取：</span>
                    <el-input v-model="myExtendInfo.day"></el-input>
                </p>
                <p v-if="myExtendInfo.day!=0">
                    <span class="span_1">每次可取N包：</span>
                    <el-input v-model="myExtendInfo.num" ></el-input>
                </p>
                <p v-if="myExtendInfo.day!=0 && myExtendInfo.num>1">
                    <span class="span_1" >每次间隔x分钟：</span>
                    <el-input v-model="myExtendInfo.interval" ></el-input>
                </p>


                <p>
                    <span class="span_1">多个广告时是否限制每天一个：</span>
                  <el-switch
                        v-model="myExtendInfo.bLimitDay"
                        active-color="#13ce66"
                        inactive-color="#dddddd"
                        active-value="1"
                        inactive-value="0"
                        >
                        </el-switch>
                </p>

                <p >
                    <span class="span_1" >取货位置限制(米)：</span>
                    <el-input v-model="myExtendInfo.posLimit" ></el-input>

                </p>

                <p >
                    <span class="span_1" >微信APPID（位置）：</span>
                    <el-input v-model="myExtendInfo.appid"></el-input>

                </p>
                <p >
                    <span class="span_1" >微信APPID（支付）：</span>
                    <el-input v-model="myExtendInfo.payappid"></el-input>

                </p>


                <p v-if="status>=22 && status<30 " >
                    <span class="span_1">闪屏画面：</span>
                    <el-input v-model="myExtendInfo.splashImg"></el-input>
                </p>
                <p v-if="status>=22 && status<30">
                    <span class="span_1">闪屏计时(s)：</span>
                    <el-input v-model="myExtendInfo.splashTime"></el-input>
                </p>
                <p v-if="status>=22 && status<30">
                    <span class="span_1">关注二维码背景：</span>
                    <el-input v-model="myExtendInfo.mainImg"></el-input>
                </p>

                <p v-if="status==23">
                    <span class="span_1">取货等待图：</span>
                    <el-input v-model="myExtendInfo.qzImg"></el-input>
                </p>

                <p>
                    <span class="span_1">取货完成跳转URL：</span>
                    <el-input v-model="myExtendInfo.jumpUrl" ></el-input>
                </p>

                </div>


                <div v-if="status==100">
                  <p  >
                      <span class="e_left">货道个数：</span>
                      <el-input v-model="myExtendInfo.length" v-show="false"></el-input>
                      <el-input v-model="laneNum" @change="changeLaneNum()"></el-input>
                  </p>

                  <p v-for="laneItem in laneInfos" class="laneInfo">
                    <span class="e_left">商品/数量</span>
                    <el-select  v-model="laneItem.goodsId"   >
                         <el-option
                              v-for="mutiGoodsItem in mutiGoodsList"
                              :key="mutiGoodsItem.goodsName"
                              :label="mutiGoodsItem.goodsName"
                              :value="mutiGoodsItem.id" 
                               >
                          </el-option>
                     </el-select>
                    <el-input v-model="laneItem.maxCount"  style="width:150px;"></el-input>
                  </p>

                </div>


            </div>
            <span @click="boxClose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
            <el-button type="success" @click="commitEditP" style="width:300px;margin-top:20px;">提交</el-button>
        </el-card>
    </div>
</template>
<script>
    //import $axios from '../../https/config'
    import $ajax from '../../https/config'
    import {isNull} from '../../js/tool'
    export default {
      props: ['addShow', 'editDvceCode', 'editStatus', 'editPoints', 'editPrice', 'editExtend', 'editGetUserinfo', 'editUserId'],
      data () {
        return {
          price: 0,
          point: 0,
          deviceCode: '',
          status: '',
          extendInfo: '',
          bExtendInfo:false,
          day:1,
          num:1,
          interval:0,
          splashImg:"",
          splashTime:"",
          mainImg:"",
          bGetUserInfo:false,
          jumpUrl:"",
          qzImg:"",
          btnLogin:false,
          posLimit:0,
          appid:"",
          payappid:"",
          bRepeat:false,
          bianhao:'',

          laneNum:0,
          laneInfos:[],
          mutiGoodsList:[]

        }
      },
      created:  function (){
        this.queryCommodityList()
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myCode: {
          get: function () {
            this.deviceCode = this.editDvceCode
            //this.bianhao =
            //return this.editDvceCode
            return !isNull(this.editDvceCode)?this.editDvceCode:this.editUserId
          },
          set: function (val) {
            this.deviceCode = val
          }
        },
        myStatus: {
          get: function () {
            console.log("this.editStatus="+this.editStatus)



            this.status = this.editStatus
            return this.editStatus
          },
          set: function (val) {
            console.log("this.editStatus val="+val)
            this.status = val
          }
        },
        myPoints: {
          get: function () {
            this.point = this.editPoints
            return this.editPoints
          },
          set: function (val) {
            this.point = val
          }
        },
        myPrice: {
          get: function () {
            this.price = this.editPrice
            return this.editPrice
          },
          set: function (val) {
            this.price = val
          }
        },
        myExtendInfo: {
          get: function () {
            //console.log("get extendInfo = "+JSON.stringify(this.editExtend));
            if (this.editExtend instanceof Array){
              console.log("array");
              this.laneNum = this.editExtend.length
              this.laneInfos = this.editExtend

            }else{
              //console.log("myExtendInfo.day="+this.extendInfo.day)
              if (isNull(this.editExtend.day)){
                this.editExtend.day = 0
                this.bRepeat = false
              }else{
                if (this.editExtend.day!=0){
                  this.bRepeat = true
                }
              }

              this.extendInfo = this.editExtend
              console.log("get extendInfo = "+JSON.stringify(this.editExtend));
            }


            

            return this.editExtend
          },
          set: function (val) {
            console.log("set extendInfo = "+JSON.stringify(val));
            this.extendInfo = val
          }
        },
        myBGetUserInfo: {
          get: function () {
            this.bGetUserInfo = this.editGetUserinfo

            return this.editGetUserinfo
          },
          set: function (val) {
            //console.log("set extendInfo = "+JSON.stringify(val));
            this.bGetUserInfo = val
          }
        }
      },
      methods: {
        changeLaneNum () {
          this.laneInfos = [];
          //console.log("mutiGoodsList1="+JSON.stringify(this.mutiGoodsList));
          if (this.mutiGoodsList.length<=0){
            alert("请先添加商品再修改货道信息");
            return;
          }

          //console.log("mutiGoodsList2"+this.mutiGoodsList[0].id);
          for (var i=0 ; i<this.laneNum; i++){
            //this.laneInfos.push({"goodsId":1,"maxCount":20});

            this.laneInfos.push({"goodsId":this.mutiGoodsList[0].id,"maxCount":20});
          }
        },

        changeRepeat () {
          if (this.extendInfo.day==0){
            this.extendInfo.day = 1
            this.extendInfo.num = 1
            this.extendInfo.interval = 0
            this.bRepeat = true
          }else{
            this.extendInfo.day = 0
            this.extendInfo.num = 0
            this.extendInfo.interval = 0
            this.bRepeat = false
          }
        },
        boxClose () {
          this.$emit('closeEditPoint', false)
        },
        queryCommodityList () {
          var _this = this

          var userInfoStr = sessionStorage.getItem('lbz-device-user-info')
          var userInfo =  JSON.parse(userInfoStr)

          var params = {
            owner :userInfo.owner,
            pageNo: 1,
            pageSize: 10000,
            keys:"",
            sort:""
          }
         
          var _this = this
          $ajax.get('/mutigoods/list', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
             /* _this.mutiGoodsList = [{id: 1, goodsName: "纸巾"}]
              if (res.resultData && res.resultData.list.length > 0) {
                _this.mutiGoodsList = _this.mutiGoodsList.concat(res.resultData.list)
              }
              console.log("_this.mutiGoodsList="+JSON.stringify(_this.mutiGoodsList));*/

              //_this.mutiGoodsList = _this.mutiGoodsList
              _this.mutiGoodsList = res.resultData.list
            } else {
            }
          })
        },
        commitEditP () {
          var _this = this
          var extendInfo="";
          var extendInfoObj = {};

          if (_this.status == 100){
            
            var url = '/mutigoods/associateDevice?deviceCode='+_this.myCode

            var params = _this.laneInfos 

            console.log("params="+JSON.stringify(params))

            $ajax.post(url , params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                _this.$message({
                  type: 'success',
                  message: '保存配置成功!'
                })
                _this.boxClose()
              } else {
                _this.$message({
                  type: 'error',
                  message: '保存配置失败!' + res.errorMessage
                })

              }
            })

            
          }else{
            if (_this.extendInfo.day==0){
              extendInfoObj.day=0;
              extendInfoObj.num=0;
              extendInfoObj.interval=0;
            }else{
              extendInfoObj.day=parseInt(_this.extendInfo.day);
              extendInfoObj.num=parseInt(_this.extendInfo.num);

              if (extendInfoObj.num>1){
                  extendInfoObj.interval=parseInt(_this.extendInfo.interval);
              }else{
                extendInfoObj.interval=0;
              }

            }

            if (_this.status>=22&&_this.status<=30){
              extendInfoObj.splashImg = _this.extendInfo.splashImg;
              extendInfoObj.splashTime = _this.extendInfo.splashTime;
              extendInfoObj.mainImg = _this.extendInfo.mainImg;
            }
            if (_this.status==23){
              extendInfoObj.splashImg = _this.extendInfo.splashImg;
              extendInfoObj.splashTime = _this.extendInfo.splashTime;
              extendInfoObj.mainImg = _this.extendInfo.mainImg;
              extendInfoObj.qzImg = _this.extendInfo.qzImg;
            }

            extendInfoObj.posLimit = isNull(_this.extendInfo.posLimit)?0:parseInt(_this.extendInfo.posLimit);
            extendInfoObj.jumpUrl = _this.extendInfo.jumpUrl;
            extendInfoObj.bLimitDay = _this.extendInfo.bLimitDay;

            if (!isNull(_this.extendInfo.appid)){
              extendInfoObj.appid=_this.extendInfo.appid;
            }

            if (!isNull(_this.extendInfo.payappid)){
              extendInfoObj.payappid=_this.extendInfo.payappid;
            }





            var params = {
              status: _this.status,
              charge: _this.price,
              bGetUserInfo: _this.bGetUserInfo,
              point:100,
              extendInfo:JSON.stringify(extendInfoObj),
              deviceCode:_this.myCode+"|"
            }
            var url = '/userChargeConfig/updateDeviceConfig'


            if (isNull(_this.editDvceCode)){
              params.deviceCode = _this.editUserId+"|"
              url = '/userChargeConfig/updateUserConfig'
            }

            $ajax.post(url , params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                _this.$message({
                  type: 'success',
                  message: '保存配置成功!'
                })
                _this.boxClose()
              } else {
                _this.$message({
                  type: 'error',
                  message: '保存配置失败!' + res.errorMessage
                })

              }
            })
          }
          


          /*var params = {
            deviceCode: _this.deviceCode,
            paymentType: _this.status,
            charge: _this.price,
            point: _this.point
          }
          $axios.get('/device/changeDevicePayType', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$message({
                type: 'success',
                duration: 1000 * 1,
                message: '修改支付流程成功!'
              })
              _this.boxClose()
            } else {
              _this.$message({
                type: 'error',
                duration: 1000 * 1,
                message: '修改支付流程失败!' + res.errorMessage
              })
            }
          })*/
        }
      }
    }
</script>
<style lang="scss">
  .edit_point {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;

      .edit_point_account {
        min-height: 330px;
        width: 700px;
        top: 10%;
        left: 50%;
        z-index: 101;
        margin-left: -350px;
        position: fixed;

        .editContent {
          text-align: left;
          margin-left: 30px;

          .el-input{
            width: 300px;
          }
          .e_left .span_1{
              width: 20%;
              display: inline-block;
          }


          .laneInfo {
            .el-select  {

              .el-input {
                width: 150px;
              }
              
            }
           }
        }

        
      }
  }

  
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/editPoint.vue